// extracted by mini-css-extract-plugin
module.exports = {"item":"Info_o_smene_item__Z2WRx","cudo":"Info_o_smene_cudo__3kpuu","title":"Info_o_smene_title__29jNJ"};